// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.ai-tabs {
  display: block;
  margin-top: 0.75rem;
}

:host ::ng-deep {
  /* Remove default PrimeNG / browser focus ring on listbox (sky blue outline) when selecting options */
}
:host ::ng-deep .gc-form-section {
  border: 1px solid #d1d5db;
  border-radius: 12px;
  margin-bottom: 16px;
}
:host ::ng-deep .gc-form-section .sidebar-form {
  padding: 25px;
}
:host ::ng-deep .gc-form-section .sidebar-form label {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 30px;
  color: #1e38a9;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-inputtext {
  height: 54px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 12px 16px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1f2937;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-inputtext:enabled:focus {
  box-shadow: none;
  border-color: #d1d5db;
}
:host ::ng-deep .gc-form-section .sidebar-form textarea.p-inputtextarea {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 12px 16px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1f2937;
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  min-height: 7rem;
  box-sizing: border-box;
  resize: vertical !important;
  overflow: auto;
}
:host ::ng-deep .gc-form-section .sidebar-form textarea.p-inputtextarea:enabled:focus {
  box-shadow: none;
  border-color: #d1d5db;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-dropdown {
  border-radius: 6px;
  border: 1px solid #d1d5db;
  min-height: 54px;
  display: flex;
  align-items: center;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-dropdown .p-dropdown-label {
  padding: 12px 16px;
  font-family: "Montserrat";
  font-weight: 500;
  font-size: 16px;
  color: #1f2937;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-dropdown:not(.p-disabled).p-focus {
  box-shadow: none;
  border-color: #d1d5db;
}
:host ::ng-deep .p-autocomplete {
  width: 100%;
}
:host ::ng-deep .p-autocomplete .p-autocomplete-input {
  width: 100%;
  border: none;
  padding: 0;
}
:host ::ng-deep .p-autocomplete .p-autocomplete-input:focus {
  box-shadow: none;
}
:host ::ng-deep .assing-agncy-filed .p-autocomplete {
  flex: 1;
}
:host ::ng-deep .p-multiselect {
  border-radius: 6px;
  border: 1px solid #d1d5db;
  padding: 14px 8px;
  width: 100%;
  background: #fff;
  min-height: 54px;
  display: flex;
  align-items: center;
}
:host ::ng-deep .p-multiselect .p-multiselect-label {
  padding: 0;
  font-size: 16px;
  color: #6b7280;
}
:host ::ng-deep .p-multiselect .p-multiselect-trigger {
  width: 24px;
  height: 24px;
  position: absolute;
  right: 12px;
}
:host ::ng-deep .ai-composer-listbox-wrap {
  width: 100%;
}
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  font-family: "Montserrat", sans-serif;
  overflow: hidden;
}
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox.p-focus,
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox:focus,
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox:focus-visible,
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox:focus-within,
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox .p-listbox-list:focus,
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox .p-listbox-list:focus-visible {
  box-shadow: none !important;
  outline: none !important;
}
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox .p-listbox-list .p-listbox-item.p-focus {
  box-shadow: none !important;
  outline: none !important;
}
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox .p-listbox-header {
  padding: 0.65rem 0.75rem 0.5rem;
  border-bottom: 1px solid #e5e7eb;
  justify-content: flex-start;
  background: #f3f4f6;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
:host ::ng-deep .ai-composer-listbox-select-all-row {
  width: 100%;
}
:host ::ng-deep .ai-composer-listbox-select-all {
  color: #0f63ac;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
}
:host ::ng-deep .ai-composer-listbox-select-all:hover {
  text-decoration: underline;
}
:host ::ng-deep .ai-composer-listbox-placeholder-text {
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  line-height: 1.4;
}
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox .p-listbox-list-wrapper {
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox .p-listbox-list .p-listbox-item {
  padding: 0.5rem 0.75rem;
  font-size: 15px;
  color: #1f2937;
  background: #fff;
  gap: 0.625rem;
}
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox .p-listbox-list .p-listbox-item > .p-checkbox {
  flex-shrink: 0;
}
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox .p-listbox-empty-message {
  padding: 0rem 0.75rem;
  font-size: 14px;
  color: #6b7280;
}
:host ::ng-deep .ai-composer-listbox-wrap .p-listbox p-scroller .p-scroller {
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
:host ::ng-deep .p-chips {
  width: 100%;
}
:host ::ng-deep .p-chips .p-chips-multiple-container {
  width: 100%;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  min-height: 54px;
  padding: 8px 12px;
}

.assing-agncy {
  height: 54px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 12px 16px;
  display: flex;
}
.assing-agncy .assing-agncy-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff url('agency-icon-blue.8eed463b0cbddad9.svg') no-repeat center center;
  background-size: 45%;
  text-align: center;
  font-weight: 600;
  flex: 0 0 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #c7c7c7;
  padding: 4px;
}
.assing-agncy .assing-agncy-filed {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
}

.active-row {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.guideline-info {
  color: #9ca3af;
  font-size: 0.85rem;
}

.guideline-help {
  font-size: 14px;
  color: #6b7280;
  margin: 0.25rem 0 0.75rem 0;
}

.guide-link {
  color: #1e38a9;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
}

.change-history-box {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  max-height: 180px;
  overflow: auto;
  background: #fff;
}

.change-history-entry {
  padding: 10px 12px;
  font-size: 14px;
  border-bottom: 1px solid #f1f5f9;
}

.change-history-entry:last-child {
  border-bottom: none;
}

.prompt-guide-content {
  max-height: calc(100vh - 170px);
  overflow: auto;
  padding: 0 1rem;
  font-size: 16px;
  line-height: 1.6;
}

.prompt-guide-content h4 {
  color: #1f2937;
  margin-top: 1.1rem;
  margin-bottom: 0.5rem;
  font-size: 32px;
  font-weight: 700;
}

.prompt-guide-content h5 {
  margin: 0 0 0.35rem;
  font-size: 16px;
  font-weight: 700;
}

.prompt-guide-content p {
  margin: 0 0 0.65rem;
  color: #374151;
}

.good-list,
.mistakes-list,
.checklist {
  margin: 0 0 1rem;
  padding-left: 0;
  list-style: none;
}

.good-list li,
.mistakes-list li,
.checklist li {
  margin: 0.4rem 0;
  padding-left: 1rem;
  position: relative;
}

.good-list li::before {
  content: "•";
  color: #2563eb;
  position: absolute;
  left: 0;
}

.mistakes-list li::before {
  content: "X";
  color: #dc2626;
  position: absolute;
  left: 0;
}

.checklist li::before {
  content: "☐";
  color: #9ca3af;
  position: absolute;
  left: 0;
}

.principles-list {
  padding-left: 1.2rem;
}

.principles-list li {
  margin-bottom: 0.85rem;
}

.principles-list p {
  margin-top: 0.25rem;
  color: #6b7280;
  font-style: italic;
}

.role-card {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 0.9rem 1rem;
  margin-bottom: 0.85rem;
}

.role-card ul {
  margin: 0;
  padding-left: 1rem;
}

.role-card li {
  margin: 0.2rem 0;
}

.template-box {
  border: 1px solid #c7d2fe;
  background: #eef2ff;
  border-radius: 10px;
  padding: 1rem;
  margin-bottom: 1rem;
  white-space: pre-line;
  font-family: "Courier New", Courier, monospace;
  font-size: 14px;
}

/* Create/update guideline fields spacing */
:host ::ng-deep .sidebar-form input[formControlName=templateTitle] {
  margin-bottom: 0.75rem;
}

:host ::ng-deep .sidebar-form textarea[formControlName=style_guide] {
  margin-bottom: 0.75rem;
}

:host ::ng-deep .sidebar-form p-dropdown[formControlName=questionType] {
  display: block;
  margin-bottom: 1.5rem;
}

.body-column-cell {
  max-width: 520px;
}

.body-column-text {
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  line-height: 1.45;
  max-height: 4.35em;
}

.visit-code-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 10px;
  border-radius: 999px;
  background: #eef2ff;
  color: #1e38a9;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  margin: 2px 6px 2px 0;
  border: 1px solid #cdd7ff;
}

:host ::ng-deep .p-chips .p-chips-token {
  margin: 2px 6px 2px 0;
  padding: 2px 8px;
  border-radius: 999px;
  background: #2d3f9f;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
}

:host ::ng-deep .p-chips .p-chips-token .p-chips-token-icon {
  color: #ffffff;
  font-size: 12px;
  margin-left: 6px;
}

.idg-tab-label {
  display: inline-flex;
  align-items: center;
  cursor: not-allowed;
}

::ng-deep .ai-tabs .p-tabview-nav {
  display: flex;
  align-items: center;
  gap: 2rem;
  margin: 0 0 0.625rem 0;
  padding: 0 1rem;
  border-bottom: 1px solid #d9d9d9;
}

::ng-deep .ai-tabs .p-tabview-nav li {
  margin: 0;
}

::ng-deep .ai-tabs .p-tabview-nav li .p-tabview-nav-link {
  min-height: 2rem;
  line-height: 1;
  font-weight: 600;
  color: #495057;
}

::ng-deep .ai-tabs .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  color: #00a651;
  border-color: #00a651;
}

::ng-deep .ai-tabs .p-tabview-panels {
  padding-top: 0.125rem;
}

.idg-placeholder {
  padding: 2rem;
  text-align: center;
  color: #666;
}`, "",{"version":3,"sources":["webpack://./src/app/ai-composer/ai-composer.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,cAAA;EACA,mBAAA;AAEF;;AAEA;EAsIE,qGAAA;AApIF;AADE;EACE,yBAAA;EACA,mBAAA;EACA,mBAAA;AAGJ;AADI;EACE,aAAA;AAGN;AADM;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAGR;AAAM;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAER;AADQ;EACE,gBAAA;EACA,qBAAA;AAGV;AACM;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,2BAAA;EACA,cAAA;AACR;AAAQ;EACE,gBAAA;EACA,qBAAA;AAEV;AAKI;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAHN;AAIM;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAFR;AAIM;EACE,gBAAA;EACA,qBAAA;AAFR;AAOE;EACE,WAAA;AALJ;AAMI;EACE,WAAA;EACA,YAAA;EACA,UAAA;AAJN;AAKM;EACE,gBAAA;AAHR;AAQE;EACE,OAAA;AANJ;AASE;EACE,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAPJ;AASI;EACE,UAAA;EACA,eAAA;EACA,cAAA;AAPN;AAUI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AARN;AAYE;EACE,WAAA;AAVJ;AAaE;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qCAAA;EACA,gBAAA;AAXJ;AAeE;;;;;;EAME,2BAAA;EACA,wBAAA;AAbJ;AAgBE;EACE,2BAAA;EACA,wBAAA;AAdJ;AAiBE;EACE,+BAAA;EACA,gCAAA;EACA,2BAAA;EACA,mBAAA;EACA,2BAAA;EACA,4BAAA;AAfJ;AAkBE;EACE,WAAA;AAhBJ;AAmBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AAjBJ;AAoBE;EACE,0BAAA;AAlBJ;AAqBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAnBJ;AAsBE;EACE,8BAAA;EACA,+BAAA;AApBJ;AAuBE;EACE,uBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;AArBJ;AAwBE;EACE,cAAA;AAtBJ;AAyBE;EACE,qBAAA;EACA,eAAA;EACA,cAAA;AAvBJ;AA0BE;EACE,8BAAA;EACA,+BAAA;AAxBJ;AA2BE;EACE,WAAA;AAzBJ;AA4BE;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;AA1BJ;;AA8BA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AA3BF;AA4BE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,qFAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;AA1BJ;AA4BE;EACE,OAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AA1BJ;;AA8BA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;AA3BF;;AA8BA;EACE,cAAA;EACA,kBAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,cAAA;EACA,2BAAA;AA3BF;;AA8BA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AA3BF;;AA8BA;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,eAAA;EACA,gCAAA;AA3BF;;AA8BA;EACE,mBAAA;AA3BF;;AA8BA;EACE,+BAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,mBAAA;EACA,cAAA;AA3BF;;AA8BA;;;EAGE,gBAAA;EACA,eAAA;EACA,gBAAA;AA3BF;;AA8BA;;;EAGE,gBAAA;EACA,kBAAA;EACA,kBAAA;AA3BF;;AA8BA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;AA3BF;;AA8BA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;AA3BF;;AA8BA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;AA3BF;;AA8BA;EACE,oBAAA;AA3BF;;AA8BA;EACE,sBAAA;AA3BF;;AA8BA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;AA3BF;;AA8BA;EACE,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;AA3BF;;AA8BA;EACE,SAAA;EACA,kBAAA;AA3BF;;AA8BA;EACE,gBAAA;AA3BF;;AA8BA;EACE,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,8CAAA;EACA,eAAA;AA3BF;;AA8BA,2CAAA;AACA;EACE,sBAAA;AA3BF;;AA8BA;EACE,sBAAA;AA3BF;;AA8BA;EACE,cAAA;EACA,qBAAA;AA3BF;;AA8BA;EACE,gBAAA;AA3BF;;AA8BA;EACE,oBAAA;EACA,aAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AA3BF;;AA8BA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;AA3BF;;AA8BA;EACE,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA3BF;;AA8BA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,oBAAA;EACA,mBAAA;EACA,mBAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;AA3BF;;AA8BA;EACE,SAAA;AA3BF;;AA8BA;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AA3BF;;AA8BA;EACE,cAAA;EACA,qBAAA;AA3BF;;AA8BA;EACE,qBAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,kBAAA;EACA,WAAA;AA3BF","sourcesContent":[".ai-tabs {\n  display: block;\n  margin-top: 0.75rem;\n}\n\n// Keep sidebar create/update form visually aligned with form-data module\n:host ::ng-deep {\n  .gc-form-section {\n    border: 1px solid #d1d5db;\n    border-radius: 12px;\n    margin-bottom: 16px;\n\n    .sidebar-form {\n      padding: 25px;\n\n      label {\n        font-family: 'Montserrat';\n        font-style: normal;\n        font-weight: 600;\n        font-size: 15px;\n        line-height: 30px;\n        color: #1e38a9;\n      }\n\n      .p-inputtext {\n        height: 54px;\n        border: 1px solid #d1d5db;\n        border-radius: 6px;\n        padding: 12px 16px;\n        font-family: 'Montserrat';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 30px;\n        color: #1f2937;\n        &:enabled:focus {\n          box-shadow: none;\n          border-color: #d1d5db;\n        }\n      }\n\n      textarea.p-inputtextarea {\n        border: 1px solid #d1d5db;\n        border-radius: 6px;\n        padding: 12px 16px;\n        font-family: 'Montserrat';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 30px;\n        color: #1f2937;\n        width: 100%;\n        max-width: 100%;\n        min-width: 100%;\n        min-height: 7rem;\n        box-sizing: border-box;\n        resize: vertical !important;\n        overflow: auto;\n        &:enabled:focus {\n          box-shadow: none;\n          border-color: #d1d5db;\n        }\n      }\n    }\n  }\n\n  .gc-form-section .sidebar-form {\n    .p-dropdown {\n      border-radius: 6px;\n      border: 1px solid #d1d5db;\n      min-height: 54px;\n      display: flex;\n      align-items: center;\n      .p-dropdown-label {\n        padding: 12px 16px;\n        font-family: 'Montserrat';\n        font-weight: 500;\n        font-size: 16px;\n        color: #1f2937;\n      }\n      &:not(.p-disabled).p-focus {\n        box-shadow: none;\n        border-color: #d1d5db;\n      }\n    }\n  }\n\n  .p-autocomplete {\n    width: 100%;\n    .p-autocomplete-input {\n      width: 100%;\n      border: none;\n      padding: 0;\n      &:focus {\n        box-shadow: none;\n      }\n    }\n  }\n\n  .assing-agncy-filed .p-autocomplete {\n    flex: 1;\n  }\n\n  .p-multiselect {\n    border-radius: 6px;\n    border: 1px solid #d1d5db;\n    padding: 14px 8px;\n    width: 100%;\n    background: #fff;\n    min-height: 54px;\n    display: flex;\n    align-items: center;\n\n    .p-multiselect-label {\n      padding: 0;\n      font-size: 16px;\n      color: #6b7280;\n    }\n\n    .p-multiselect-trigger {\n      width: 24px;\n      height: 24px;\n      position: absolute;\n      right: 12px;\n    }\n  }\n\n  .ai-composer-listbox-wrap {\n    width: 100%;\n  }\n\n  .ai-composer-listbox-wrap .p-listbox {\n    width: 100%;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    background: #fff;\n    font-family: 'Montserrat', sans-serif;\n    overflow: hidden;\n  }\n\n  /* Remove default PrimeNG / browser focus ring on listbox (sky blue outline) when selecting options */\n  .ai-composer-listbox-wrap .p-listbox.p-focus,\n  .ai-composer-listbox-wrap .p-listbox:focus,\n  .ai-composer-listbox-wrap .p-listbox:focus-visible,\n  .ai-composer-listbox-wrap .p-listbox:focus-within,\n  .ai-composer-listbox-wrap .p-listbox .p-listbox-list:focus,\n  .ai-composer-listbox-wrap .p-listbox .p-listbox-list:focus-visible {\n    box-shadow: none !important;\n    outline: none !important;\n  }\n\n  .ai-composer-listbox-wrap .p-listbox .p-listbox-list .p-listbox-item.p-focus {\n    box-shadow: none !important;\n    outline: none !important;\n  }\n\n  .ai-composer-listbox-wrap .p-listbox .p-listbox-header {\n    padding: 0.65rem 0.75rem 0.5rem;\n    border-bottom: 1px solid #e5e7eb;\n    justify-content: flex-start;\n    background: #f3f4f6;\n    border-top-left-radius: 6px;\n    border-top-right-radius: 6px;\n  }\n\n  .ai-composer-listbox-select-all-row {\n    width: 100%;\n  }\n\n  .ai-composer-listbox-select-all {\n    color: #0f63ac;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    text-decoration: none;\n  }\n\n  .ai-composer-listbox-select-all:hover {\n    text-decoration: underline;\n  }\n\n  .ai-composer-listbox-placeholder-text {\n    font-size: 14px;\n    font-weight: 500;\n    color: #6b7280;\n    line-height: 1.4;\n  }\n\n  .ai-composer-listbox-wrap .p-listbox .p-listbox-list-wrapper {\n    border-bottom-left-radius: 6px;\n    border-bottom-right-radius: 6px;\n  }\n\n  .ai-composer-listbox-wrap .p-listbox .p-listbox-list .p-listbox-item {\n    padding: 0.5rem 0.75rem;\n    font-size: 15px;\n    color: #1f2937;\n    background: #fff;\n    gap: 0.625rem;\n  }\n\n  .ai-composer-listbox-wrap .p-listbox .p-listbox-list .p-listbox-item > .p-checkbox {\n    flex-shrink: 0;\n  }\n\n  .ai-composer-listbox-wrap .p-listbox .p-listbox-empty-message {\n    padding: 0rem 0.75rem;\n    font-size: 14px;\n    color: #6b7280;\n  }\n\n  .ai-composer-listbox-wrap .p-listbox p-scroller .p-scroller {\n    border-bottom-left-radius: 6px;\n    border-bottom-right-radius: 6px;\n  }\n\n  .p-chips {\n    width: 100%;\n  }\n\n  .p-chips .p-chips-multiple-container {\n    width: 100%;\n    border-radius: 6px;\n    border: 1px solid #d1d5db;\n    min-height: 54px;\n    padding: 8px 12px;\n  }\n}\n\n.assing-agncy {\n  height: 54px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  padding: 12px 16px;\n  display: flex;\n  .assing-agncy-img {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    overflow: hidden;\n    background: #fff url(../../assets/images/agency-icon-blue.svg) no-repeat center center;\n    background-size: 45%;\n    text-align: center;\n    font-weight: 600;\n    flex: 0 0 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #c7c7c7;\n    padding: 4px;\n  }\n  .assing-agncy-filed {\n    flex: 1;\n    position: relative;\n    display: flex;\n    align-items: center;\n  }\n}\n\n.active-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.guideline-info {\n  color: #9ca3af;\n  font-size: 0.85rem;\n}\n\n.guideline-help {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0.25rem 0 0.75rem 0;\n}\n\n.guide-link {\n  color: #1e38a9;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.change-history-box {\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  max-height: 180px;\n  overflow: auto;\n  background: #fff;\n}\n\n.change-history-entry {\n  padding: 10px 12px;\n  font-size: 14px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.change-history-entry:last-child {\n  border-bottom: none;\n}\n\n.prompt-guide-content {\n  max-height: calc(100vh - 170px);\n  overflow: auto;\n  padding: 0 1rem;\n  font-size: 16px;\n  line-height: 1.6;\n}\n\n.prompt-guide-content h4 {\n  color: #1f2937;\n  margin-top: 1.1rem;\n  margin-bottom: 0.5rem;\n  font-size: 32px;\n  font-weight: 700;\n}\n\n.prompt-guide-content h5 {\n  margin: 0 0 0.35rem;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.prompt-guide-content p {\n  margin: 0 0 0.65rem;\n  color: #374151;\n}\n\n.good-list,\n.mistakes-list,\n.checklist {\n  margin: 0 0 1rem;\n  padding-left: 0;\n  list-style: none;\n}\n\n.good-list li,\n.mistakes-list li,\n.checklist li {\n  margin: 0.4rem 0;\n  padding-left: 1rem;\n  position: relative;\n}\n\n.good-list li::before {\n  content: '•';\n  color: #2563eb;\n  position: absolute;\n  left: 0;\n}\n\n.mistakes-list li::before {\n  content: 'X';\n  color: #dc2626;\n  position: absolute;\n  left: 0;\n}\n\n.checklist li::before {\n  content: '☐';\n  color: #9ca3af;\n  position: absolute;\n  left: 0;\n}\n\n.principles-list {\n  padding-left: 1.2rem;\n}\n\n.principles-list li {\n  margin-bottom: 0.85rem;\n}\n\n.principles-list p {\n  margin-top: 0.25rem;\n  color: #6b7280;\n  font-style: italic;\n}\n\n.role-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 0.9rem 1rem;\n  margin-bottom: 0.85rem;\n}\n\n.role-card ul {\n  margin: 0;\n  padding-left: 1rem;\n}\n\n.role-card li {\n  margin: 0.2rem 0;\n}\n\n.template-box {\n  border: 1px solid #c7d2fe;\n  background: #eef2ff;\n  border-radius: 10px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  white-space: pre-line;\n  font-family: 'Courier New', Courier, monospace;\n  font-size: 14px;\n}\n\n/* Create/update guideline fields spacing */\n:host ::ng-deep .sidebar-form input[formControlName='templateTitle'] {\n  margin-bottom: 0.75rem;\n}\n\n:host ::ng-deep .sidebar-form textarea[formControlName='style_guide'] {\n  margin-bottom: 0.75rem;\n}\n\n:host ::ng-deep .sidebar-form p-dropdown[formControlName='questionType'] {\n  display: block;\n  margin-bottom: 1.5rem;\n}\n\n.body-column-cell {\n  max-width: 520px;\n}\n\n.body-column-text {\n  display: -webkit-box;\n  line-clamp: 3;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: normal;\n  line-height: 1.45;\n  max-height: calc(1.45em * 3);\n}\n\n.visit-code-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px 10px;\n  border-radius: 999px;\n  background: #eef2ff;\n  color: #1e38a9;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 18px;\n  margin: 2px 6px 2px 0;\n  border: 1px solid #cdd7ff;\n}\n\n:host ::ng-deep .p-chips .p-chips-token {\n  margin: 2px 6px 2px 0;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #2d3f9f;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 18px;\n}\n\n:host ::ng-deep .p-chips .p-chips-token .p-chips-token-icon {\n  color: #ffffff;\n  font-size: 12px;\n  margin-left: 6px;\n}\n\n.idg-tab-label {\n  display: inline-flex;\n  align-items: center;\n  cursor: not-allowed;\n}\n\n::ng-deep .ai-tabs .p-tabview-nav {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n  margin: 0 0 0.625rem 0;\n  padding: 0 1rem;\n  border-bottom: 1px solid #d9d9d9;\n}\n\n::ng-deep .ai-tabs .p-tabview-nav li {\n  margin: 0;\n}\n\n::ng-deep .ai-tabs .p-tabview-nav li .p-tabview-nav-link {\n  min-height: 2rem;\n  line-height: 1;\n  font-weight: 600;\n  color: #495057;\n}\n\n::ng-deep .ai-tabs .p-tabview-nav li.p-highlight .p-tabview-nav-link {\n  color: #00a651;\n  border-color: #00a651;\n}\n\n::ng-deep .ai-tabs .p-tabview-panels {\n  padding-top: 0.125rem;\n}\n\n.idg-placeholder {\n  padding: 2rem;\n  text-align: center;\n  color: #666;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
